export const REVIT_RULES = {
  MODEL: {
    INCH: {
      MIN: .5,
      MAX: 848.5
    },
    MM: {
      MIN: 12.7,
      MAX: 21552
    }
  },
  DRAFTING: {
    INCH: {
      MIN: .002,
      MAX: 84.85
    },
    MM: {
      MIN: .051,
      MAX: 2155
    }
  }
}

export const AUTOCAD_RULES = {
  MIN: .001,
  MAX: 65536/2/2/2
}

// export const cellErrorCheck_bail = (v, format, type, units) => {

//   if(format === 'REVIT'){
//     if(v < REVIT_RULES[type][units].MIN){
//       return {
//         limit: REVIT_RULES[type][units].MIN,
//         value: v,
//         type: 'TOO_SMALL'
//       }
//     }
//     if(v > REVIT_RULES[type][units].MAX){
//       return {
//         limit: REVIT_RULES[type][units].MAX,
//         value: v,
//         type: 'TOO_BIG'
//       }
//     }
//   }

//   if(format === 'AUTOCAD'){
//     if(v < AUTOCAD_RULES.MIN){
//       return {
//         limit: AUTOCAD_RULES.MIN,
//         value: v,
//         type: 'TOO_SMALL'
//       }
//     }
//     if(v > AUTOCAD_RULES.MAX){
//       return {
//         limit: AUTOCAD_RULES.MAX,
//         value: v,
//         type: 'TOO_BIG'
//       }
//     }
//   }

//   return;
// }

export const cellErrorCheck = (v, format, type, units, minimumOnly) => {

  if(format === 'REVIT' && !minimumOnly){
    if(v < REVIT_RULES[type][units].MIN){
      return {
        limit: REVIT_RULES[type][units].MIN,
        value: v,
        type: 'TOO_SMALL'
      }
    }
    if(v > REVIT_RULES[type][units].MAX){
      return {
        limit: REVIT_RULES[type][units].MAX,
        value: v,
        type: 'TOO_BIG'
      }
    }
  }

  if(format === 'AUTOCAD' || minimumOnly){
    if(v < AUTOCAD_RULES.MIN){
      return {
        limit: AUTOCAD_RULES.MIN,
        value: v,
        type: 'TOO_SMALL'
      }
    }
    if(v > AUTOCAD_RULES.MAX){
      return {
        limit: AUTOCAD_RULES.MAX,
        value: v,
        type: 'TOO_BIG'
      }
    }
  }

  return;
}

// export const rowErrorCheck = (cells, format, type, units) => {
//   var errors = {};

//   if(format === 'REVIT'){
//     // check offset 
//     errors.offest = cellErrorCheck(cells[4], format, type, units);
    
//     var sum = 0;
//     for(var i = 5; i < cells.length; i++){
//       sum += Math.abs(cells[i]);
//     }

//     errors.dash_space = cellErrorCheck(sum, format, type, units);
//   }

//   return Object.keys(errors).length === 0 ? false : errors;
// }



// WEBPACK FOOTER //
// ./src/pattern_utilities/cellErrorCheck.js